import { getServiceCollectionsWithEligibilityStatus } from "../../actions/api";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getMyRequests } from "../../actions";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ServiceCollectionListItem from "./ServiceCollectionListItem";
import { List, Input, Space, Checkbox, Switch } from "antd";
import { PageHeader1 } from "../headers/PageHeaders";
import { ClusterOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import "../listcard.css";

const { Search } = Input;

const ServiceCollectionList = ({
  getServiceCollectionsWithEligibilityStatus,
  serviceCollections,
  isLoading,
}) => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [filter, setFilter] = useState(
    searchParams.get("service_collection") || "",
  );
  const [filterStatusEnabled, setFilterStatusEnabled] = useState(false);
  const serviceCollectionStatuses = [
    { label: "Subscribed", value: "Subscribed" },
    { label: "Eligible", value: "Eligible" },
    { label: "Eligible with guarantor", value: "EligibleWithApproval" },
    { label: "Not Eligible", value: "NotEligible" },
  ];
  const [checkedList, setCheckedList] = useState(
    serviceCollectionStatuses.map((s) => s.value),
  );

  useEffect(() => {
    getServiceCollectionsWithEligibilityStatus();
  }, [getServiceCollectionsWithEligibilityStatus]);

  const handleRefresh = () => {
    dispatch(getMyRequests());
    getServiceCollectionsWithEligibilityStatus();
  };

  const search = async (value) => {
    const searchValue = value ? value.toLowerCase() : "";
    setFilter(searchValue);

    // Remove query params if the search is cleared
    if (!searchValue) {
      setSearchParams({});
    }
  };

  const checkAllServiceCollectionStatuses =
    serviceCollectionStatuses.length === checkedList.length;
  const indeterminate =
    checkedList.length > 0 &&
    checkedList.length < checkAllServiceCollectionStatuses.length;
  const onCheckedServiceCollectionStatusesChange = (list) => {
    setCheckedList(list);
  };
  const onCheckAllServiceCollectionStatusesChange = (e) => {
    setCheckedList(e.target.checked ? serviceCollectionStatuses : []);
  };
  const toggle = () => {
    setFilterStatusEnabled(!filterStatusEnabled);
  };

  return (
    <div>
      <PageHeader1
        title="Service Eligibility and Subscription"
        subTitle="Collections of services to which you may subscribe if eligible."
        icon={<ClusterOutlined />}
        search={
          <>
            Filters: <Switch size="small" onChange={toggle} />
            <Search
              placeholder="Search Collections"
              allowClear
              value={filter}
              onChange={(e) => search(e.target.value)}
              onPressEnter={(e) => search(e.target.value)}
              onClear={() => search()}
              loading={isLoading}
              style={{ marginBottom: "5px" }}
            />
          </>
        }
      />

      {filterStatusEnabled && (
        <Space style={{ marginBottom: "10px" }}>
          Filter:
          <Checkbox
            indeterminate={indeterminate}
            onChange={onCheckAllServiceCollectionStatusesChange}
            checked={checkAllServiceCollectionStatuses}
          >
            All
          </Checkbox>
          <Checkbox.Group
            options={serviceCollectionStatuses}
            value={checkedList}
            onChange={onCheckedServiceCollectionStatusesChange}
          />
        </Space>
      )}

      <List
        grid={{
          gutter: 16,
          xs: 1,
          sm: 2,
          md: 2,
          lg: 3,
          xl: 3,
          xxl: 3,
        }}
        loading={isLoading}
        dataSource={
          checkAllServiceCollectionStatuses ||
          serviceCollectionStatuses.length <= 0
            ? filter
              ? serviceCollections.filter(
                  (collection) =>
                    collection.serviceCollection.displayName
                      .toLowerCase()
                      .includes(filter) ||
                    (collection.serviceCollection.description
                      ? collection.serviceCollection.description
                          .toLowerCase()
                          .includes(filter)
                      : false),
                )
              : serviceCollections
            : serviceCollections.filter((x) => checkedList.includes(x.status))
        }
        renderItem={(item) => (
          <List.Item>
            <ServiceCollectionListItem
              serviceCollection={item}
              onChange={handleRefresh}
            />
          </List.Item>
        )}
        //locale={{ emptyText: "No services are available. If you think this is an error, please contact Service Desk."}}
      />
    </div>
  );
};

// export default ServiceCollectionList;
ServiceCollectionList.propTypes = {
  getServiceCollectionsWithEligibilityStatus: PropTypes.func.isRequired,
  serviceCollections: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default connect(
  (state) => ({
    serviceCollections: state.serviceCollections.data.sort((a, b) =>
      a.serviceCollection.displayName.localeCompare(
        b.serviceCollection.displayName,
      ),
    ),
    isLoading: state.serviceCollections.loading,
  }),
  {
    getServiceCollectionsWithEligibilityStatus,
  },
)(ServiceCollectionList);
